import { InjectionToken } from '@angular/core';

/**
 * Import translations
 */
import { LANG_EN_TRANS } from './lang-en';
import { LANG_DE_TRANS } from './lang-de';
import { LANG_FR_TRANS } from './lang-fr';
import { LANG_NL_TRANS } from './lang-nl';
import { LANG_IT_TRANS } from './lang-it';
import { LANG_ES_TRANS } from './lang-es';
import { LANG_PL_TRANS } from './lang-pl';
import { LANG_SV_SE_TRANS } from './lang-sv_SE';
import { LANG_PT_TRANS } from './lang-pt';
import { LANG_RU_TRANS } from './lang-ru';
import { LANG_ZH_CN_TRANS } from './lang-zh_CN';
import { LANG_HU_TRANS } from './lang-hu';
import { LANG_EN_US_TRANS } from './lang-en_US';
import { LANG_KO_TRANS } from './lang-ko';
import { LANG_JA_TRANS } from './lang-ja';

/**
 * Translation token
 * @type {InjectionToken<string>}
 */
export const TRANSLATIONS = new InjectionToken<string>('translations');

/**
 * All translations.
 * Format: {'property': 'translation value';}
 */
export const dictionary = {
    en: LANG_EN_TRANS,
    de: LANG_DE_TRANS,
    fr: LANG_FR_TRANS,
    nl: LANG_NL_TRANS,
    it: LANG_IT_TRANS,
    es: LANG_ES_TRANS,
    pl: LANG_PL_TRANS,
    sv_SE: LANG_SV_SE_TRANS,
    pt: LANG_PT_TRANS,
    ru: LANG_RU_TRANS,
    zh_CN: LANG_ZH_CN_TRANS,
    hu: LANG_HU_TRANS,
    en_US: LANG_EN_US_TRANS,
    ko: LANG_KO_TRANS,
    ja: LANG_JA_TRANS
};

/**
 * Providers
 * {provide: InjectionToken<string>; useValue: {'property': 'translation value'}}
 */
export const TRANSLATION_PROVIDERS = [
    {provide: TRANSLATIONS, useValue: dictionary},
];



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/translations.ts